import { render } from "./MessageDetail.vue?vue&type=template&id=066bd29e"
import script from "./MessageDetail.vue?vue&type=script&lang=js"
export * from "./MessageDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__